import { requestPost } from '@/common/request';

interface reqParams {
  groupId?: number; //	组Id 修改时必须传
  noticeTip?: number; // 消息是否弹窗 0-关闭  1-启用 不传默认是0
  noticeMail?: number; // 消息是否通知邮件 0-通知 1-不通知 不传默认是0
  noticeDongDong?: number; // 消息是否通知咚咚 0-通知 1-不通知 不传默认是0
}

interface ResultData {
  data: boolean;
}

/**
 * 消息中心-分组消息弹窗
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericGroupMessageGroupTip(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestPost('/generic/platMktMsgBk/group/messageGroupTip', query);
}
